import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { CommonDataService } from '@sb-tools/typescript/services/common-data.service';
import { environment } from '@environment';

export const apiInterceptor: HttpInterceptorFn = (req, next) => {
    const commonDataService = inject(CommonDataService);

    if (isNeedAuthApi(req.url)) {
        const headers = req.headers.set('X-Token', commonDataService.xToken);
        const clonedRequest = req.clone({ headers });
        return next(clonedRequest);
    } else if (req.url.toLowerCase().indexOf(environment.apiMasterUrl.toLowerCase()) === 0) {
        const headers = req.headers.set('community', commonDataService.community);
        const clonedRequest = req.clone({ headers });
        return next(clonedRequest);
    }

    return next(req);
};

function isNeedAuthApi(requestUrl: string): boolean {
    const requestUrlLower = requestUrl.toLowerCase();

    return (
        requestUrlLower.indexOf(environment.apiInboxUrl.toLowerCase()) === 0 ||
        (environment.signalrServerUrl && requestUrlLower.indexOf(environment.signalrServerUrl.toLowerCase())) === 0
    );
}
